<template>
  <div class="login">
    <div class="login__top">
      <span class="login__title">
        ZMIEŃ HASŁO
      </span>
      <span class="login__close" @click="closeModal" />
    </div>
    <div class="login__form">
      <LoginModalInput type="password" placeholder="Stare hasło" v-model="oldPassword"/>
      <LoginModalInput type="password" placeholder="Nowe hasło" v-model="newPassword"/>
            <LoginModalInput type="password" placeholder="Powtórz nowe hasło" v-model="repeatPassword"/>



    </div>
    <span class="login__invalid" v-if="invalid">Podane hasła nie zgadzają się.</span>

    <div class="login__buttons">
    <SelectButton buttonName="Zatwierdż" :action='changePassword' />




    <button class="login__cancel" @click='closeModal'>anuluj</button>
    </div>
  </div>
</template>

<script>
import SelectButton from '@/ui/SelectButton.vue';
import LoginModalInput from '@/ui/LoginModalInput.vue';
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    SelectButton,
    LoginModalInput
  }
};
</script>

<style scoped lang="scss">
.login {
  width: 94%;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &__buttons {
    width: 28%;
  }
  &__invalid {
    color: red;
  }
  &__top {
    height: 3rem;
    width: 100%;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    position: relative;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
 display: flex;
    align-items: center;

  }
  &__title {
    font-family: 'Poppins';
    color: white;
    margin-left: 1rem;

  }
  &__form {
    width: 66%;
    display: flex;
    flex-direction: column;
    margin-top: 2.5rem;
  }
  &__close {
    color: #fff;
    font-size: 30px;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    width: 1.25rem;
    height: 1.25rem;
    display: block;
    background-image: url("~@/assets/loginModal__close.png");
    background-size: cover;
    background-position: center;
  }

  &__flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 66%;
    font-family: "Poppins", sans-serif;
    color: #5e5a6b;
    font-style: italic;
  }
  .flex {
    &__checkbox {
      margin: 0;

      &:hover {
        cursor: pointer;
      }
    }
    &__remember {
      display: flex;
      align-items: center;
      font-size: 11px;
    }
    &__forgot {
      font-size: 11px;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    &__label {
      margin-left: 0.5rem;
      &:hover {
        cursor: pointer;
      }
    }
  }


  &__cancel {
    width: 100%;
    height: 2.5rem;
    font-size: 1rem;
    text-transform: uppercase;
    border: none;
    border-radius: 5px;
    color: #0f1626;
    letter-spacing: 0.8px;
    margin-bottom: 1rem;

    background-color: transparent;
    cursor: pointer;
    &:hover {
      background-color: darken(#fff, 10%);
    }
  }
}
</style>
